import React, { memo, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Label, Popover, PopoverBody, PopoverHeader, Input, Button } from "reactstrap";
import { systemLabelActions } from "../../store/actions/system/systemLabel/systemLabel.action";
import "./SystemLabel.css";
import routes from "../../routes";
import { history } from "../../helpers/history";
import { getKey } from "../../helpers/UrlHelper";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@material-ui/core";
function systemLabelIsEqual(prevProps, nextProps) {
  if (prevProps.systemLabels === nextProps.systemLabels && prevProps.systemLabels.loading == prevProps.systemLabels.loading && prevProps.systemLabels.groups === nextProps.systemLabels.groups)
    return true;
  else return false;
}
const SystemLabel = memo(({ dispatch, groupName, name, user, systemLabels, asOption, asOption2, cms }) => {
  const { groups } = systemLabels;
  const [gName, setGroupName] = useState(null);
  const [creating, setCreating] = useState(false);
  const [isSaveable, setIsSaveable] = useState(false);
  const [open, setOpen] = useState(false);
  const [languageCode, setLanguageCode] = useState("swe");
  const isEditable = user && user.admin;
  const [editLabel, setEditLabel] = useState(null);
  const { location } = history;
  const [loaded, setLoaded] = useState(false);

  const labelList = useMemo(() => {
    if (groups && groups[gName]) return groups[gName];
    else return null;
  }, [groups]);
  useEffect(() => {
    let langCode = null;
    if (location && location.search) {
      const params = new URLSearchParams(location.search);
      langCode = params.get(getKey("languageCode", params));
      if (!langCode) langCode = params.get(getKey("lang", params));
      if (langCode && langCode.length > 3) {
        langCode = langCode.substr(0, 3);
      }
    }

    if (!langCode && user) langCode = user.userLang;
    else if (!langCode && cms.languageCode) {
      langCode = cms.languageCode;
    } else if (!langCode) langCode = "swe";

    if (langCode !== languageCode) setLanguageCode(langCode);

    if (groupName) setGroupName(groupName);
    else {
      let activeRoute = routes.find((r) => {
        return comparePaths(location.pathname, r.path);
      });
      setGroupName(activeRoute.labelGroup);
    }
  }, []);

  useEffect(() => {
    if (!loaded && gName && languageCode && (!systemLabels.loading || !groups || !groups[gName])) {
      dispatch(systemLabelActions.getGroup(languageCode, gName));
      setLoaded(true);
    }
  }, [gName, languageCode, groups]);

  const label = useMemo(() => {
    let currLabel = null;
    if (!labelList) return null;
    currLabel = labelList.find((l) => {
      return l.name === name && l.languageCode === (languageCode ? languageCode : (user && user.userLang) || "swe");
    });
    if (currLabel) {
      if (creating) {
        setCreating(false);
      }
      return currLabel;
    } else {
      if (!creating) {
        dispatch(systemLabelActions.create(name, languageCode, gName));
        setCreating(true);
      }
      return null;
    }
  }, [labelList]);

  const comparePaths = (p1, p2) => {
    //Special case, change this later on
    if (p1.includes("/register/") && p2.includes("/register/")) {
      return true;
    }
    if (p1.includes("/p/") && p2.includes("/p/")) {
      return true;
    }
    if (p1.includes("/survey/") && p2.includes("/survey/")) {
      return true;
    }
    if (p1.includes("/web/") && p2.includes("/web/")) {
      return true;
    }
    if (p1.includes("/digitalarena/") && p2.includes("/digitalarena/")) {
      return true;
    }
    if (p1.includes("/backstage/") && p2.includes("/backstage/")) {
      return true;
    }
    if (p1.includes("/editor/") && p2.includes("/editor/")) {
      return true;
    }
    if (p1.includes("/digitalmeeting/") && p2.includes("/digitalmeeting/")) {
      return true;
    }
    if (p1.includes("/session/moderator/") && p2.includes("/session/moderator/")) {
      return true;
    }
    if (p1.includes("/session/client/") && p2.includes("/session/client/")) {
      return true;
    }
    if (p1.includes("/presenter/") && p2.includes("/presenter/")) {
      return true;
    }
    if (p1.includes("/session/stage/") && p2.includes("/session/stage/")) {
      return true;
    }
    if (p1.includes("/session/chatmoderator/") && p2.includes("/session/chatmoderator/")) {
      return true;
    }
    if (p1.includes("/exhibitor/") && p2.includes("/exhibitor/")) {
      return true;
    }
    if (p1.includes("/exhibitor2/") && p2.includes("/exhibitor2/")) {
      return true;
    }
    if (p1.includes("/booth/") && p2.includes("/booth/")) {
      return true;
    }
    const locRegex = /\/\d+.*/g;
    const pathRegex = /\/:id/g;
    p1 = p1.replace(locRegex, "").replace(pathRegex, "").toLowerCase();
    p2 = p2.replace(locRegex, "").replace(pathRegex, "").toLowerCase();
    return p1 === p2;
  };
  const toggle = (e) => {
    if (isEditable && e.ctrlKey === true) {
      e.stopPropagation();
      if (!open) setEditLabel({ ...label });
      setOpen(!open);
    }
  };
  const handleChange = (field, e) => {
    let newLabel = { ...editLabel };
    newLabel[field] = e.target.value;
    setEditLabel(newLabel);
    if (!isSaveable) {
      setIsSaveable(true);
    }
  };
  const onKeyPressed = (e) => {
    if (e.keyCode == 13 && e.shiftKey === false) {
      e.preventDefault();
      save();
    }
  };
  const stopShit = (e) => {
    if (open) {
      e.stopPropagation();
    }
  };
  const save = () => {
    const { systemLabelId, languageCode, value, hint } = editLabel;

    if (open && isSaveable) {
      dispatch(systemLabelActions.update(systemLabelId, value, hint, languageCode, groupName));
    }
    setOpen(false);
    setIsSaveable(false);
    label.value = value;
    label.hint = hint;
    setEditLabel(null);
  };
  const cancel = () => {
    setOpen(false);
    setIsSaveable(false);
    setEditLabel(null);
  };
  const onFocus = (e) => {
    e.target.select();
  };

  if (asOption && label) {
    return (
      <option key={label.systemLabelId} value={asOption}>
        {label.value}
      </option>
    );
  } else if (asOption2 && label) {
    return { value: asOption2, label: label.value };
  } else {
    return (
      <React.Fragment>
        {label && (
          <span id={"label_" + label.systemLabelId} className="ignore-click" onClick={toggle}>
            {label.value}
            {isEditable && open && editLabel ? (
              <Popover placement="auto" style={{ zIndex: 10000 }} isOpen={open} target={"label_" + label.systemLabelId} onClick={stopShit}>
                <PopoverHeader>{label.name + ` (${label.languageCode})[${gName}]`}</PopoverHeader>
                <PopoverBody>
                  <Row>
                    <Col className="md-12">
                      <Label htmlFor={label.systemLabelId}>Value</Label>
                      <Input
                        id={label.systemLabelId}
                        autoFocus
                        onFocus={onFocus}
                        value={editLabel.value || ""}
                        style={{ width: "250px" }}
                        onChange={(e) => handleChange("value", e)}
                        onKeyDown={onKeyPressed}
                      />
                    </Col>
                    <Col className="md-12">
                      <Label htmlFor={"hint_" + label.systemLabelId}>Hint</Label>
                      <Input
                        type="textarea"
                        id={"hint_" + label.systemLabelId}
                        value={editLabel.hint || ""}
                        style={{ minHeight: "100px" }}
                        onChange={(e) => handleChange("hint", e)}
                        onKeyDown={onKeyPressed}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col>
                      <Button disabled={!isSaveable} color="success" style={{ marginRight: "5px" }} onClick={save}>
                        Save
                      </Button>
                      <Button onClick={cancel}>Cancel</Button>
                    </Col>
                  </Row>
                </PopoverBody>
              </Popover>
            ) : null}
            {label.hint && label.hint.length > 0 ? (
              <React.Fragment>
                &nbsp;
                <Tooltip title={<span>{label.hint}</span>}>
                  <InfoOutlinedIcon id={"tip_" + label.systemLabelId} style={{ cursor: "help", fontSize: "1rem" }} />
                </Tooltip>
              </React.Fragment>
            ) : null}
          </span>
        )}
      </React.Fragment>
    );
  }
}, systemLabelIsEqual);

function mapStateToProps(state) {
  return {
    user: state.authentication.user,
    systemLabels: state.systemLabels,
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(SystemLabel);
